export const CHAR_MAX_LENGTH = 255

export const CHATBOT_NAME_LIMIT = 50
export const WORKFLOW_NAME_LIMIT = CHAR_MAX_LENGTH
export const ACTIVECAMPAIGN_API_CREDENTIALS_LIMIT = CHAR_MAX_LENGTH
export const TRIGGER_NAME_LIMIT = CHAR_MAX_LENGTH
export const BROADCAST_NAME_LIMIT = 40
export const KEYWORD_NAME_LIMIT = 40
export const CAMPAIGN_NAME_LIMIT = 40
export const POWER_DIALER_NAME_LIMIT = 40
export const TEXT_TO_SPEECH_AUDIO_NAME = 96
export const TEXT_TO_SPEECH_VOICE_NAME = 30
export const MERGE_FIELD_FALLBACK_LIMIT = 30
export const KEYWORD_DESCRIPTION_LIMIT = 50
export const MAX_VALID_INTERNATIONAL_NUMBER_LENGTH = 14
export const MAX_VALID_NUMBER_LENGTH = 12
export const MIN_VALID_NUMBER_LENGTH = 9
export const INBOX_NAME_LIMIT = 40

export const MAX_ITEMS_PER_PAGE = 100

export const BYTE_SIZE_5_MB = 5 * 1024 * 1024
export const CLICK_TO_TEXT_NAME_LIMIT = 40
export const TAGS_NAME_LIMIT = 50
export const USER_FIRST_NAME_LIMIT = 60
export const USER_LAST_NAME_LIMIT = 60
